import moment from 'moment';

export const checkUserAccess = (
  authUser,
  selectedEmployee,
  performanceHeader,
) => ({
  isEmployee:
    authUser?.employeeId?.toLowerCase().trim() ===
    selectedEmployee?.value?.toLowerCase()?.trim(),
  isCompleted: performanceHeader?.[0]?.Confirmation_Result === 2 || false,
  isCalibrationCompleted:
    performanceHeader?.[0]?.Calibration_Result === 2 || false,
});

export const showKPIs = (isEmployee, performanceHeader) => {
  let show = false;
  if (isEmployee) {
    show = true;
  } else if (!isEmployee && performanceHeader?.[0]?.Define_Objectives === 2) {
    show = true;
  }
  return show;
};

export const calculateWeightage = performanceDetails => {
  let pcmWtg = 0;
  let performanceWtg = 0;

  performanceDetails?.forEach(item => {
    if (item?.KPI_Type === 'PCM' && typeof item?.Weightage === 'number') {
      pcmWtg += item.Weightage;
    }
    if (
      item?.KPI_Type === 'PERFORMANCE' &&
      typeof item?.Weightage === 'number'
    ) {
      performanceWtg += item.Weightage;
    }
  });
  return { pcmWtg, performanceWtg };
};

export const getPerformanceWeightage = data => {
  if (data?.result?.length > 0) {
    return {
      performanceWeightage:
        data?.result?.[0]?.Performance_Weightage_Percentage || 0,
      pcmWeightage: data?.result?.[0]?.PCM_Weightage_Percentage || 0,
    };
  }
  return {
    performanceWeightage: 0,
    pcmWeightage: 0,
  };
};

export const validateSubmission = (
  header,
  performanceDetails,
  weightagePercentage,
) => {
  if (header?.Define_Objectives === 1) {
    const pcmKPI = performanceDetails?.filter(item => item?.KPI_Type === 'PCM');
    const performanceKPI = performanceDetails?.filter(
      item => item?.KPI_Type === 'PERFORMANCE',
    );

    if (performanceDetails?.length === 0) {
      return {
        isValid: false,
        message: 'Please add at least one KPI before submitting.',
      };
    }

    if (performanceKPI?.length === 0) {
      return {
        isValid: false,
        message: 'Please add at least one Performance KPI before submitting.',
      };
    }

    if (pcmKPI?.length === 0) {
      return {
        isValid: false,
        message: 'Please add at least one PCM KPI before submitting.',
      };
    }
  }

  if (header?.Confirm_Objectives === 1) {
    const missingWeightage = performanceDetails?.filter(
      item => !item?.Weightage,
    );
    if (missingWeightage?.length > 0) {
      return {
        isValid: false,
        message: 'Please assign a weight to each KPI before submitting.',
      };
    }

    const performanceTotalWeightage = performanceDetails
      ?.filter(item => item?.KPI_Type === 'PERFORMANCE')
      ?.reduce((acc, item) => acc + (item?.Weightage || 0), 0);

    const pcmTotalWeightage = performanceDetails
      ?.filter(item => item?.KPI_Type === 'PCM')
      ?.reduce((acc, item) => acc + (item?.Weightage || 0), 0);

    const performanceWeightage =
      getPerformanceWeightage(weightagePercentage)?.performanceWeightage;
    const pcmWeightage =
      getPerformanceWeightage(weightagePercentage)?.pcmWeightage;

    if (
      performanceTotalWeightage < performanceWeightage &&
      pcmTotalWeightage < pcmWeightage
    ) {
      return {
        isValid: false,
        message: `Total Performance weightage must be at least ${performanceWeightage}% and PCM weightage must be at least ${pcmWeightage}%.`,
      };
    }

    if (performanceTotalWeightage < performanceWeightage) {
      return {
        isValid: false,
        message: `Total Performance weightage must be at least ${performanceWeightage}%.`,
      };
    }

    if (pcmTotalWeightage < pcmWeightage) {
      return {
        isValid: false,
        message: `Total PCM weightage must be at least ${pcmWeightage}%.`,
      };
    }
  }

  if (header?.Self_Assessment === 1) {
    const missingSelfRating = performanceDetails?.filter(
      item => !item?.Rating_Self,
    );
    if (missingSelfRating?.length > 0) {
      return {
        isValid: false,
        message:
          'Some KPIs are missing self-ratings. Please complete them before submitting.',
      };
    }
  }

  if (header?.Manager_Review === 1) {
    const missingManagerRating = performanceDetails?.filter(
      item => !item?.Rating_Mgr,
    );
    if (missingManagerRating?.length > 0) {
      return {
        isValid: false,
        message:
          'Some KPIs are missing manager-ratings. Please complete them before submitting.',
      };
    }
  }

  if (header?.Calibration_Result === 1 && !header?.Overall_Rating_Calibration) {
    return {
      isValid: false,
      message:
        'Some KPIs are missing calibration. Please complete them before submitting.',
    };
  }

  return { isValid: true, message: '' };
};

export const showReleaseButton = data =>
  data?.length > 0 &&
  data?.some(
    item =>
      item?.Session_Status !== 'Released' &&
      item?.Session_Status !== 'Cancelled',
  );

export const showDueDate = (headerData, dueDateData) => {
  if (!headerData || !dueDateData) return '-';

  let dueDate = '-';
  if (headerData?.Define_Objectives === 1) {
    dueDate = dueDateData?.Define_Objectives_Due_Date
      ? moment(dueDateData?.Define_Objectives_Due_Date).format('DD/MM/YYYY')
      : '-';
  } else if (headerData?.Confirm_Objectives === 1) {
    dueDate = dueDateData?.Confirm_Objectives_Due_Date
      ? moment(dueDateData?.Confirm_Objectives_Due_Date).format('DD/MM/YYYY')
      : '-';
  } else if (headerData?.Self_Assessment === 1) {
    dueDate = dueDateData?.Self_Assessment_Due_Date
      ? moment(dueDateData?.Self_Assessment_Due_Date).format('DD/MM/YYYY')
      : '-';
  } else if (headerData?.Manager_Review === 1) {
    dueDate = dueDateData?.Manager_Review_Due_Date
      ? moment(dueDateData?.Manager_Review_Due_Date).format('DD/MM/YYYY')
      : '-';
  } else if (headerData?.Calibration_Result === 1) {
    dueDate = dueDateData?.Calibration_Result_Due_Date
      ? moment(dueDateData?.Calibration_Result_Due_Date).format('DD/MM/YYYY')
      : '-';
  } else if (headerData?.Confirmation_Result === 1) {
    dueDate = dueDateData?.Confirmation_Result_Due_Date
      ? moment(dueDateData?.Confirmation_Result_Due_Date).format('DD/MM/YYYY')
      : '-';
  }
  return dueDate;
};
